"use strict";

require("../../style/index.css");

require("./index.css");


//////////////////
// WEBPACK FOOTER
// /Users/balazskaxd/dev/rkk/rkk-webapp/~/antd/lib/layout/style/css.js
// module id = 565
// module chunks = 20